import Vue from 'vue'
import { gigJobPartiesMixin, statusesMixin } from '../mixins'

export default Vue.extend<any, any, any, any>({
  mixins: [gigJobPartiesMixin, statusesMixin],
})
